import { ITtsItemData, TTtsGenerationStatus } from 'types/text-to-speech'

export const TTS_DEFAULT_LANG_CODE = 'en-US'
export const TTS_DEFAULT_SPEAKER_ID = 24 //John speaker id
export const TTS_DEFAULT_BULK_SPEAKER_ID = -1
export const TTS_DEFAULT_BULK_LANG_CODE = 'langCode'
export const TTS_DEFAULT_INSTRUCTION = ''
export const TTS_DEFAULT_BULK_INSTRUCTION = 'bulkInstruction'

export const TTS_DEFAULT_SPEED = 1

// The AI Avatar flow fetches its voices from a dedicated TTS model.
export const AVATAR_TTS_VOICE_MODEL = 'tts-worker'
// Default voice for the AI Avatar flow (a `tts-worker` speaker).
export const AVATAR_TTS_DEFAULT_SPEAKER_ID = 81

export const TTS_BULK_DEFAULT_SPEED = -1
export const TTS_AUDIO_CLASS_NAME_WITH_ID = 'tts-audio-'

export const TTS_TYPE = 'TTS'

export const TTS_ITEM_DATA_CHANGEABLE_KEYS: {
  [key: string]: keyof ITtsItemData
} = {
  speakerId: 'speakerId',
  speed: 'speed',
  langCode: 'langCode',
  instructions: 'instructions',
  text: 'text'
}

export const MULTILINGUAL_LANGUAGE_ID = 'multi'

export const SECONDS_IN_MINUTE = 60

export const TTS_GENERATION_STATUS: Record<
  TTtsGenerationStatus,
  TTtsGenerationStatus
> = {
  processing: 'processing',
  ok: 'ok',
  error: 'error'
}
